var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"single-column-layout",attrs:{"fluid":""}},[_c('router-view'),_c('GlobalNotifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }